/**
 * userpreferencesreducer.js
 * Created by calhosh on 8/28/2020.
 */
import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import {confidentialityTypes} from '../../util/uiconstants';

export function userPreferencesReducer(state = initialState.userPreferences, action) {
	switch (action.type) {
		case types.GET_USER_PREFERENCES: {
			let userPreferences = action.response;

			userPreferences.userConfidentialityTypeId = 0;

			if (userPreferences && userPreferences.permissions) {
				if (userPreferences.permissions.hasLowConfidentiality) {
					userPreferences.userConfidentialityTypeId = confidentialityTypes.LOW;
				}

				if (userPreferences.permissions.hasModerateConfidentiality) {
					userPreferences.userConfidentialityTypeId = confidentialityTypes.MODERATE;
				}

				if (userPreferences.permissions.hasHighConfidentiality) {
					userPreferences.userConfidentialityTypeId = confidentialityTypes.HIGH;
				}

				// if (userPreferences.permissions.hasConfidentialConfidentiality) {
				// 	userPreferences.userConfidentialityTypeId = confidentialityTypes.CONFIDENTIAL;
				// }
			}

			userPreferences.isPreferencesLoaded = true;

			return userPreferences;
		}
		default:
			return state;
	}
}

export function internalUserReducer(state = initialState.internalUser, action) {
	switch (action.type) {
		case types.GET_INTERNAL_USER_BY_ID: {
			return action.response;
		}
		default:
			return state;
	}
}
